module.exports = __webpack_public_path__ + "static/367117_0_0-9f37f065b42f19ad46a27674857e3e39.woff";